import React from 'react'
import { useLazyQuery } from '@apollo/react-hooks'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

import { Button, Checkbox, FormControlLabel, Input, MenuItem, TextField } from '@mui/material'
import { useAuthentication } from '../../hooks/useAuthentication'
import { PAYMENT_ACCOUNT_LABELS, PaymentAccount } from '../../types'
import { hasFullReportsAccess } from '../../utils/utils'
// import { VoucherType } from '../../types'
import { EXPORT_VOUCHERS } from './gql'
import Loader from '../Loader'


const ExportVouchers = () => {
  // start of the year date
  const startOfYear = new Date(new Date().getFullYear(), 0, 1)

  const jwtToken = localStorage.getItem('jwtToken') || ''
  const [dateFrom, setDateFrom] = React.useState(startOfYear.toISOString())
  const [dateTo, setDateTo] = React.useState(new Date().toISOString())

  // const [skip, setSkip] = React.useState(0)
  // const [take, setTake] = React.useState(150)

  const { authState } = useAuthentication()
  const canFilterByAccount = hasFullReportsAccess(authState.authUser.department?.name)
  const [paidFrom, setPaidFrom] = React.useState('All')
  const [international, setInternational] = React.useState(false)

  const [fetchData, { loading, error, data }] = useLazyQuery(EXPORT_VOUCHERS)

  //if (toDate && fromDate) {

  // call this endpoint when the toDate and fromDate are set
  const fetchVouchers = async () => {
    fetchData({
      variables: {
        input: {
          dateTo,
          dateFrom,
          skip: 0,
          take: 150,
          payment_account: paidFrom !== 'All' ? paidFrom : undefined,
          international,
        },
      },
      context: { headers: { authorization: jwtToken } },
    })
  }
  //}

  if (error) return <p>ERROR</p>

  return (
    <Paper square elevation={0}>
      <Typography variant="h6" component="div">
        <Input
          type="date"
          defaultValue={startOfYear.toISOString().split('T')[0]}
          onChange={(e) => setDateFrom(new Date(e.target.value).toISOString())}
          style={{ margin: '10px' }}
        />
        {' - '}
        <Input
          type="date"
          defaultValue={new Date().toISOString().split('T')[0]}
          onChange={(e) => setDateTo(new Date(e.target.value).toISOString())}
          style={{ margin: '10px' }}
        />
        {
          /*
          TODO: Add more filters here
           like status, department, pay to, created by, claimed by, financial year
          */
        }
        {canFilterByAccount && (
          <TextField
            select
            size="small"
            label="Paid from"
            value={paidFrom}
            onChange={(e) => setPaidFrom(e.target.value)}
            style={{ margin: '10px', minWidth: 160 }}
          >
            <MenuItem value="All">All</MenuItem>
            {(Object.keys(PAYMENT_ACCOUNT_LABELS) as PaymentAccount[]).map(
              (account) => (
                <MenuItem key={account} value={account}>
                  {PAYMENT_ACCOUNT_LABELS[account]}
                </MenuItem>
              ),
            )}
          </TextField>
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={international}
              onChange={(e) => setInternational(e.target.checked)}
            />
          }
          label="International only"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => fetchVouchers()}
          disabled={!dateTo || !dateFrom}
          style={{ margin: '10px' }}
        >
          Export
        </Button>
      </Typography>
      {loading && <Loader />}
      {data && data.export.signedLink && (
        <a href={data.export.signedLink}>Download</a>
      )}
    </Paper>
  )
}

export default ExportVouchers